'use client';

import { useMemo } from 'react';

const hashString = (str: string): number => {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = Math.imul(h, 31) + str.charCodeAt(i);
  }
  return h;
};

export const useShuffleBySeed = <T extends string>(items: readonly T[], seed = ''): T[] =>
  useMemo(() => [...items].sort((a, b) => hashString(seed + a) - hashString(seed + b)), [items, seed]);
